import React from "react";

import style from "./styles.module.scss";

interface PageTitleProps {
  subtitle: string;
  title: string;
}

export default function PageTitle({ subtitle, title }: PageTitleProps) {
  return (
    <header className={style.pageTitle}>
      <h1 className={`pgm-headline-small ${style.title}`}>{title}</h1>
      <p className={`pgm-body-large ${style.subtitle}`}>{subtitle}</p>
    </header>
  );
}
